<!-- Root outlet only: layout shells are attached at route level, never wrapped here. -->
<router-outlet></router-outlet>
